<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h2>گروه ها</h2>

            <router-link class="btn btn-primary ml-auto" to="/dashboard/UserGroup">ساخت گروه جدید</router-link>
            <div class="table-responsive mt-4">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>نام گروه</th>
                    <th>وضعیت</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="group in groups" :key="group._id">
                    <td>{{ group.title }}</td>
                    <td>
                      <button class="btn btn-danger mr-4" @click="removeGroup(group)">حذف</button>
                      <router-link :to="{ path: '/dashboard/UserGroup', query: { id: group._id } }">مشاهده</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PermissionService from '../../../../services/UsersRulePermissions';
export default {
  name: 'Groups',
  data() {
    return {
      groups: [],
    };
  },
  created() {
    this.getGroups();
  },
  methods: {
    async removeGroup(group) {
      try {
        await PermissionService.deleteGroup(group._id);
        window.notif({ mssg: 'گروه با موفقیت حذف شد', isError: false });
        this.getGroups();
      } catch (err) {
        console.log(err);
        window.notif({ mssg: 'مشکلی پیش آمده', isError: true });
      }
    },

    async getGroups() {
      try {
        const resData = await PermissionService.getGroups({});
        this.groups = resData;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
